import writeText from 'copy-to-clipboard'
import { ClipboardCheckIcon, ClipboardIcon, GiftIcon } from 'lucide-react'
import { useState } from 'react'
import { Button } from '@/components/ui/button'

const LAUNCH_COUPON_CODE = 'FIRST100'

export function LaunchCouponCode() {
  const [couponIsCopied, setCouponIsCopied] = useState(false)

  const handleCopyCode = () => {
    writeText(LAUNCH_COUPON_CODE)
    setCouponIsCopied(true)
  }

  return (
    <div className="mx-auto mb-4 flex items-center justify-center">
      <div className="mx-2 flex size-7 shrink-0 items-center justify-center rounded-full border border-purple-400 bg-gradient-to-br from-purple-400 to-purple-800 shadow-md">
        <GiftIcon size={15} className="text-white" />
      </div>
      <div className="-mr-5 flex h-6 items-center justify-center whitespace-nowrap rounded-full bg-muted pr-7 pl-3 font-medium text-sm leading-none">
        Get 10% off
        <span className="whitespace-pre-wrap max-sm:hidden"> with our launch deal</span>
      </div>
      <Button
        size="sm"
        className="[&_svg]:-translate-y-px h-6 select-text rounded-full px-2 font-bold font-mono text-xs tracking-wide transition-all active:scale-95 [&_>_div]:gap-1.5"
        onClick={handleCopyCode}
      >
        {LAUNCH_COUPON_CODE}
        {couponIsCopied ? <ClipboardCheckIcon /> : <ClipboardIcon />}
      </Button>
    </div>
  )
}
